<template>
	<div class="list-group border-radius-2 no-border" v-if="loadedconfig">
		<WidgetHeader :link="settings.link">{{ $t('longitudinal-tracking') }}</WidgetHeader>
        <slot name="header" class="mb-1"/>
		<div class="list-group-item p-8">
			<Roadmap
                :title="null"
                :events="timelineData" 
                :width="900" 
                :height="600"
            />
		</div>
	</div>
</template>

<script>
import WidgetHeader from "src/components/widgets/WidgetHeader";
import Roadmap from 'src/components/Roadmap/Roadmap.vue';  

export default {
    props: {
        settings: {
            type: Object,
            default: () => ({
                header: 'widget-header',
                link: "/",
                reportroute:""
            })
        }
    },
	components: {
		WidgetHeader,
        Roadmap

	},
	data() {
		return {
			loadedconfig: true,
            timelineData: [
                {
                    id: 1,
                    title: 'Start of the year',
                    date: '2025-04-04',
                    description: 'Initial point'
                },
                {
                    id: 2,
                    title: 'First milestone',
                    date: '2025-06-19',
                    description: 'Birthday'
                },
                {
                    id: 3,
                    title: 'Second milestone',
                    date: '2025-09-10',
                    description: 'More stuff'
                },
                {
                    id: 4,
                    title: 'Exam',
                    date: '2025-10-15',
                    description: 'Study'
                }
            ]
        }
	},
	mounted() {
		this.getReportConfig();
	},
	methods: {
		unableToGetSettings() {
			const self = this;
			this.$store.commit("openDialog" , {
				title: this.$t('oops'),
				content: this.$t('unable-to-get-report-settings'),
				confirmCallBack: function(){
					self.$router.replace('/');
				}
			});
		},
		getReportConfig(){
			this.$cfetch(`${this.$settings.APIBaseURL}/reporting/report/${this.settings.reportroute}`, {
				cache: false,
				init: {
					method: "post",
					body: {
					}
				}
			})
			.then(json => {
				if (json.status === "SUCCESS") {
					this.$log.info.call(this, "Report config loaded");
					this.loadedconfig = json.result;
				} else {
					this.$log.error.call(this, "Could not fetch report widget settings");
				}
			})
			.catch(error => {
				this.$log.error.call(this, error);
			});
		}
	}
};
</script>
